import { render, staticRenderFns } from "./UsuarioActivo.vue?vue&type=template&id=162e4bda"
import script from "./UsuarioActivo.vue?vue&type=script&lang=js"
export * from "./UsuarioActivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports